<template>
	<v-row>
		<v-col cols="12" lg="4">
			<locum-dashboard-main />
		</v-col>

		<v-col class="stickycomponent" cols="12" lg="8" sticky fixed>
			<div v-if="$vuetify.breakpoint.width >= 1264">
				<!-- <locum-dashboard-key /> -->
				<locum-dashboard-big-calendar />
			</div>
		</v-col>
	</v-row>
</template>

<script>
//import DashboardSidebar from "@/components/ui/DashboardSidebar";
import LocumDashboardMain from '@/components/ui/dashboard/locum/LocumDashboardMain';
import LocumDashboardBigCalendar from '@/components/ui/dashboard/locum/LocumDashboardBigCalendar';
// import LocumDashboardKey from '@/components/ui/dashboard/locum/cards/LocumDashboardKey';
//import { Calendar } from "dayspan";

export default {
	name: 'LocumDashboard',
	components: {
		LocumDashboardMain,
		LocumDashboardBigCalendar,
		// LocumDashboardKey,
	},
	data: () => ({}),
	computed: {},
};
</script>

<style>
* {
	text-transform: none !important;
}
</style>
